// import React from "react";
import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import MakeAppoinment from '../components/make-appoinment';
import Filter from "../components/Marketfilter";
import useGaspAnimations from '../components/useGsapAnimations';

function MarketPublicSector() {
     useGaspAnimations()
     
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
          {/* <!--Start breadcrumb area-->      */}
                {/* <section className="breadcrumb-area">
                    <div className="container text-center">
                        <h1>Heat Pumps</h1>
                    </div>
                </section> */}
                {/* <!--End breadcrumb area--> */}

                {/* <!--Start breadcrumb bottom area--> */}
                {/* <section className="breadcrumb-botton-area">
                    <div className="container">
                        <div className="left">
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li><a href="services.html">Market</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li className="active">Public Sector Units (PSUs)</li>
                            </ul>    
                        </div>
                    </div>
                </section> */}
                {/* <!--End breadcrumb bottom area--> */}

                {/* <!--Start service single area--> */}
                <section id="service-single-area">
                    <div className="container">
                        <div className="row">
                            <Filter/>      
                            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                                <div className="service-single-content">
                                    {/* <!--Start top content --> */}
                                    <div className="row top-content">
                                        <div className="col-md-5 col-sm-12 col-xs-12">
                                            <div className="img-holder wow zoomInStable animated bdFadeUp">
                                                  <Slider {...settings}>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                  </Slider>
                                             
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12 col-xs-12">
                                            <div className="textholder">
                                                <div className="sec-title bdFadeUp">
                                                    <h1><span>Public Sector Units (PSUs)</span></h1>
                                                </div>
                                                <div className="text bdFadeUp">
                                                    <span>Trusted Refrigeration Partner for Mission-Critical Government Projects</span>
                                                    <p className="top">
                                                       Indus Refrigeration has a long-standing track record of delivering high-performance refrigeration and HVAC solutions to India’s Public Sector Units (PSUs) across various domains including defense, energy, agriculture, healthcare, and infrastructure. As a preferred partner for several government-backed initiatives and turnkey projects, Indus combines technical excellence with timely execution, ensuring reliability, compliance, and value for public sector investments.
                                                    </p>
                                                    <p>
                                                       Our systems are designed to meet the diverse requirements of PSUs—from cold chain development under government schemes to process refrigeration in state-owned refineries, laboratories, and manufacturing units. Indus has successfully executed projects for organizations like FCI, NTPC, IOCL, BHEL, DRDO, and state-level cooperative dairies and agro-processing boards.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--End top content --> */}
                                    {/* <div className="row">
                                        <div className="col-md-12">
                                            <div className="border"></div>
                                        </div>
                                    </div> */}
                                     <div className="row">
                                        <div className="col-md-12">
                                            <div className="project-description">
                                                <div className="sec-title bdFadeUp">
                                                    <h2>Key Offerings for PSUs:</h2>
                                                </div>
                                                    <p>Turnkey cold storage and warehousing projects under MIDH, PMKSY, and NHM</p>

                                                    <p>Large-scale chilling plants and process refrigeration for industrial PSUs</p>

                                                    <p>Customized HVAC systems for defense labs, hospitals, and public sector R&D centers</p>

                                                    <p>Cold chain infrastructure for public health, immunization, and agri-exports</p>

                                                    <p>High-capacity ammonia- and Freon-based systems built to CPCB and BIS standards</p>

                                                    <p>End-to-end project lifecycle management: design, fabrication, installation, testing, and AMC</p>

                                                    <p>With a strong focus on quality, transparency, and statutory compliance, Indus Refrigeration supports the public sector in building sustainable, future-ready refrigeration infrastructure that contributes to national development and public welfare.</p>
                                               </div>    
                                        </div>
                                    </div>
                                 
                                </div>
                            </div>  
                        </div>
                    </div>    
                </section>
                {/* <!--End service single area--> */}
                 {/* <!--Start Consultation form--> */}
                     <MakeAppoinment/>
                    {/* <!--End Consultation form--> */}
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default MarketPublicSector;


